import { render } from "./BoxLoader.vue?vue&type=template&id=660c5f2c&scoped=true"
import script from "./BoxLoader.vue?vue&type=script&lang=js"
export * from "./BoxLoader.vue?vue&type=script&lang=js"

import "./BoxLoader.vue?vue&type=style&index=0&id=660c5f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660c5f2c"]])

export default __exports__